import { render, staticRenderFns } from "./atom.tabRandomize.vue?vue&type=template&id=d5a35c58"
import script from "./atom.tabRandomize.vue?vue&type=script&lang=ts"
export * from "./atom.tabRandomize.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports